import { Link } from "react-router-dom";
import LabelTypography from "./LabelTypography";
import { colorPrincipale } from "../../util/env";

function LinkTypography({ children, sx = {}, ...props }) {
  return (
    <Link
      {...props}
      style={{ textDecoration: "none", color: colorPrincipale, ...sx }}
    >
      <LabelTypography>{children}</LabelTypography>
    </Link>
  );
}

export default LinkTypography;
